import Link from 'next/link';
import { ResultExport } from '@/components/tools/ResultExport';
import styles from './tools.module.css';

export function PricingResult({
  result,
  format,
  exportText,
  exportTool,
}: {
  result: { low: number; high: number } | null;
  format: string;
  exportText?: string | null;
  exportTool?: string;
}) {
  const pounds = new Intl.NumberFormat('en-GB', {
    style: 'currency',
    currency: 'GBP',
    maximumFractionDigits: 0,
  });
  return (
    <div className={styles.result}>
      <div aria-live="polite">
        <p className={styles.resultTitle}>Illustrative sponsorship range</p>
        <p className={styles.resultValue}>
          {result
            ? `${pounds.format(result.low)} to ${pounds.format(result.high)}`
            : 'Add your figures'}
        </p>
        <p className={styles.resultHint}>
          {result
            ? `For one ${format.toLowerCase()}. Based on the model described below.`
            : 'Complete the fields above to calculate a range.'}
        </p>
        {result && (
          <p className={styles.resultHint}>
            Check production costs, usage rights and exclusivity before quoting.
          </p>
        )}
      </div>
      {result && exportText && exportTool ? (
        <ResultExport text={exportText} filename={`${exportTool}-scenario`} tool={exportTool} />
      ) : null}
      {result && (
        <div className={styles.resultCta}>
          <p>
            Put your work and rates beside your connected account stats. OwlScran creates your media
            kit for free.
          </p>
          <Link href="/signin" className={styles.button}>
            Get my free media kit
          </Link>
        </div>
      )}
    </div>
  );
}
